import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types'
import SearchResults from './SearchResults'
import {FaTimes} from 'react-icons/fa'
import debounce from 'lodash/debounce'
import {logAnalyticEvent} from '../../util'

let SearchModal = ({closeSearch}, context) => {

  const [searchString, setSearchString] = useState('')
  const [initialSearch, setinitialSearch] = useState(true)

  function closeModal() {
    closeSearch()
  }

  const logSearchQuery = useCallback(debounce(runLogSearch, 1000), []);

  function runLogSearch(query) {
    logAnalyticEvent('search', {query: query})
  }

  function handleSearchChange(e) {
    let val = e.target.value.replace("#", "No. ").replace(' no ',' No. ').replaceAll('  ', ' ').replaceAll('  ', ' ')
    setSearchString(val)
    setinitialSearch(false)
    logSearchQuery(val)
  }

  return (
      <div className="search_modal">
        <a className="close_button" onClick={closeModal}><FaTimes /></a>
        <div className="row">
          <div className="columns">
              <input type="text" placeholder="Search…" className="search_box" autoComplete="off" autoCorrect="off" autoCapitalize="off"
              spellCheck="false" autoFocus onChange={handleSearchChange} />
          </div>
        </div>
        { initialSearch && <div className="row">
          <div className="columns">
            <p className="search_hint">Type to search titles, composers, and performers.</p>
          </div>
        </div>
        }
        <div className="row">
          <div className="columns results">
            <SearchResults searchString={searchString} />
          </div>
        </div>
      </div>
  )
}

SearchModal.propTypes = {
  closeSearch: PropTypes.func,

}


export default SearchModal